import { AltUnit } from '../models/units';

/**
 * @param {AltUnit} unit
 * @param {number} quantity
 * @returns converted unit
 */
export const unitConversion = (unit: AltUnit, quantity: number) => {
  const factor = unit.numerator / unit.denominator;
  const conversion = parseFloat((quantity / factor).toFixed(3));
  return conversion;
};
